/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

import uuid from "react-uuid";

export const videos = [
  {
    _id: uuid(),
    title: "Next.js Crash Course",
    creator: "Traversy Media",
    views: "592k",
    subscribers: "1.85M",
    duration: "1:09:44",
    posted_at: "3 days ago",
    category: "javascript",
    videoId: "mTz0GXj8NN0",
    url: "https://www.youtube.com/embed/mTz0GXj8NN0",
    thumbnail: "https://i3.ytimg.com/vi/mTz0GXj8NN0/maxresdefault.jpg",
    creator_icon:
      "https://yt3.ggpht.com/ytc/AKedOLSxHOOxxa9Af8Bfb2XMop3lm4tor9bViWiC-d5aaw=s900-c-k-c0x00ffffff-no-rj",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "Should You Use Tailwind CSS?",
    creator: "Web Dev Simplified",
    views: "182k",
    subscribers: "927k",
    duration: "07:46",
    posted_at: "1 week ago",
    category: "css",
    videoId: "hdGsFpZ0J2E",
    url: "https://www.youtube.com/embed/hdGsFpZ0J2E",
    thumbnail: "https://img.youtube.com/vi/hdGsFpZ0J2E/maxresdefault.jpg",
    creator_icon:
      "https://yt3.ggpht.com/ytc/AKedOLQpvSjzSCSo8ZKCjBZS7TRX7omb_kyQirh2zgEY=s900-c-k-c0x00ffffff-no-rj",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "I built a chat app in 7 minutes with React & Firebase",
    creator: "Fireship",
    views: "784k",
    subscribers: "1.32M",
    duration: "08:52",
    posted_at: "1 day ago",
    category: "react",
    videoId: "zQyrwxMPm88",
    url: "https://www.youtube.com/embed/zQyrwxMPm88",
    thumbnail: "https://img.youtube.com/vi/zQyrwxMPm88/maxresdefault.jpg",
    creator_icon:
      "	https://yt3.ggpht.com/ytc/AKedOLR5CDv14gL4DQ7I4gxIlBMY6u-CNsq2qfeev48R2g=s900-c-k-c0x00ffffff-no-rj",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "Learn flexbox the easy way",
    creator: "Kevin Powell",
    views: "154k",
    subscribers: "528k",
    duration: "34:03",
    posted_at: "1 month ago",
    category: "css",
    videoId: "u044iM9xsWU",
    url: "https://www.youtube.com/embed/u044iM9xsWU",
    thumbnail: "https://img.youtube.com/vi/u044iM9xsWU/maxresdefault.jpg",
    creator_icon:
      "https://yt3.ggpht.com/ytc/AKedOLT1tLx7BgAa7_SHaXE0hDRjQu1BRihsEDZ3lmUUcg=s900-c-k-c0x00ffffff-no-rj",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "The Story of Concurrent React",
    creator: "uidotdev",
    views: "107k",
    subscribers: "52k",
    duration: "11:58",
    posted_at: "24 hours ago",
    category: "react",
    videoId: "NZoRlVi3MjQ",
    url: "https://www.youtube.com/embed/NZoRlVi3MjQ",
    thumbnail: "https://img.youtube.com/vi/NZoRlVi3MjQ/maxresdefault.jpg",
    creator_icon:
      "https://yt3.ggpht.com/4-_80xHFXwX27JazINVIscTnJMZyJ2cpu3oa_SZr3ICSqiTb_YMrPJfB1wTxvPfRmFFJfaQ8=s900-c-k-c0x00ffffff-no-rj",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "Git Tutorial for Beginners",
    creator: "Programming with Mosh",
    views: "1M",
    subscribers: "2.48M",
    duration: "1:09:13",
    posted_at: "last week",
    category: "trending",
    videoId: "8JJ101D3knE",
    url: "https://www.youtube.com/embed/8JJ101D3knE",
    thumbnail: "https://img.youtube.com/vi/8JJ101D3knE/maxresdefault.jpg",
    creator_icon:
      "https://yt3.ggpht.com/tBEPr-zTNXEeae7VZKSZYfiy6azzs9OHowq5ZvogJeHoVtKtEw2PXSwzMBKVR7W0MI7gyND8=s900-c-k-c0x00ffffff-no-rj",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "What is an API?",
    creator: "CodeWithHarry",
    views: "900k",
    subscribers: "2.7M",
    duration: "12:35",
    posted_at: "18 hours ago",
    category: "html",
    videoId: "E0Qqpn8ymko",
    url: "https://www.youtube.com/embed/E0Qqpn8ymko",
    thumbnail: "https://img.youtube.com/vi/E0Qqpn8ymko/maxresdefault.jpg",
    creator_icon:
      "https://yt3.ggpht.com/ytc/AKedOLT3EnMXtIOvDT4CL7obl0-acSZCBhMuapXBQFksVQ=s900-c-k-c0x00ffffff-no-rj",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    _id: uuid(),
    title: "MUI5 Crash Course",
    creator: "Laith Academy",
    views: "57k",
    subscribers: "29k",
    duration: "1:38:34",
    posted_at: "2 weeks ago",
    category: "trending",
    videoId: "o1chMISeTC0",
    url: "https://www.youtube.com/embed/o1chMISeTC0",
    thumbnail: "https://img.youtube.com/vi/o1chMISeTC0/maxresdefault.jpg",
    creator_icon:
      "https://yt3.ggpht.com/t_TrBp9Vyn2nhEJh5uz6Z9f8JbxVA_KZvkJSLiJadQRCmFF_wkHmnTL1y8dCqP7VWU4lLLmBmw=s900-c-k-c0x00ffffff-no-rj",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
];
